// Inits
// $.noConflict();

sleeknote.navigation.init();
//sleeknote.postload.init();
sleeknote.blogprogress.init();
sleeknote.slideshow.init();
sleeknote.tabbed.init();
sleeknote.stickyfloat.init();
sleeknote.codeSnippet.init();
sleeknote.frontpage.init();
sleeknote.listFilter.init();
sleeknote.anchorScroll.init();

$(document).ready(function(){

    var timeline = $(".timeline-item");

    if ( timeline ) {
        inView.threshold(0.5);
        inView(".timeline-item").on("enter", function(el) {
            if (!el.classList.contains('visible')) {
                el.classList.add('visible');
            }
        });
    }

    var $companyLogo = $('.js-clearbit-logo img');

    if ( $companyLogo ) {
        $.getJSON('https://reveal.clearbit.com/v1/companies/reveal?authorization=pk_fd3fe1662b68a0dcb3bcd4a84932075c', function(data) {
            var $logo_src       = '',
                $cb_src         = data.company ? data.company.logo : '',
                $default_src    = $companyLogo.attr('data-default-src');

            if ( $cb_src && $cb_src != '' ) {
                $logo_src = $cb_src;
            } else {
                $logo_src = $default_src;
            }

            $companyLogo.attr({src: $logo_src});
        });
    }

    var inview_elements = $('.js-inview-element');

    if ( inview_elements ) {
        inView.threshold(0.5);
        inView('.js-inview-element').on('enter', function(el) {
            if ( !el.classList.contains('shown') ) {
                el.classList.add('shown');

                if ( el.classList.contains('js-inview-campaign') ) {
                    anime({
                        targets: el.querySelectorAll('.js-inview-child-multiple'),
                        scale: [0,1],
                        delay: anime.stagger(50)
                    });
                } else if ( el.classList.contains('js-inview-logowall') ) {
                    anime({
                        targets: el.querySelectorAll('.js-inview-child-multiple'),
                        opacity: [0,1],
                        translateY: ['-20px','0px'],
                        delay: anime.stagger(50)
                    });
                } else if ( el.classList.contains('js-inview-goals') ) {
                    anime({
                        targets: el.querySelectorAll('.js-inview-child-multiple'),
                        opacity: [0,1],
                        translateY: ['-20px','0px'],
                        duration: 2000,
                        delay: anime.stagger(60)
                    });
                }
            }
        });
    }

    var cases           = $('.js-wall-container'),
        lead_carousel   = $('.leadgen-image-carousel');

    if ( cases ) {
        var windowHeight        = window.innerHeight;

        var cases_eTop          = cases.offset().top,
            cases_height        = windowHeight + cases.outerHeight();

        var lead_eTop           = lead_carousel.offset().top,
            lead_height         = windowHeight + lead_carousel.outerHeight();

        // console.log(lead_eTop);

        $(window).scroll(function() { //when window is scrolled
            var scrollTop               = $(window).scrollTop(),
                cases_scrollTop         = cases_eTop - scrollTop,
                cases_bottom            = windowHeight - cases_scrollTop;

            if ( cases_bottom > 0 && cases_bottom < cases_height ) {
                var cases_transform = cases_bottom * .1;
                
                anime({
                    targets: '.js-wall-container > span:nth-child(odd)',
                    translateX: -cases_transform+'px',
                    easing: 'linear',
                    duration: 0
                });
                anime({
                    targets: '.js-wall-container > span:nth-child(even)',
                    translateX: cases_transform+'px',
                    easing: 'linear',
                    duration: 0
                });
            }

            var lead_scrollTop         = lead_eTop - scrollTop,
                lead_bottom            = windowHeight - lead_scrollTop;

            if ( lead_bottom > 0 && lead_bottom < lead_height ) {
                var lead_transform = lead_bottom * .75;

                anime({
                    targets: '.leadgen-image-carousel .leadgen-image-carousel-inner',
                    translateY: -lead_transform+'px',
                    easing: 'linear',
                    duration: 0
                });
            }
        });
    }
});